import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";

export default function Asynchronous({ labelId, id, label, name, className, tipo, array, onOptionSelected, busquedaInput, valueOnLoad, disabled = false, staticOptions = [] }) {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState(staticOptions);
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [mostrarCargar, setMostrarCargar] = useState("none");
  const [hasSearched, setHasSearched] = useState(false);

  let tiempoEspera;

  useEffect(() => {
    if(valueOnLoad !== undefined && valueOnLoad !== null && valueOnLoad != value)
    setValue(valueOnLoad)
  }, [valueOnLoad])

  useEffect(() => {
    if (inputValue) {
      setLoading(true);
      setMostrarCargar("block");
      setHasSearched(true);

      clearTimeout(tiempoEspera);
      tiempoEspera = setTimeout(() => {
        busquedaInput(name, inputValue);
        setMostrarCargar("none");

      }, 800);

    } else {
      setLoading(false);
      setMostrarCargar("none");
      setHasSearched(false);
      busquedaInput(name, inputValue);
    }

    return () => clearTimeout(tiempoEspera);
  }, [inputValue]);

  useEffect(() => {
    if (hasSearched && array.length > 0) {
      const filteredArray = array.filter(item => !staticOptions.some(s => s.id === item.id));
      setOptions([...staticOptions, ...filteredArray]);
      setLoading(false);
    } else {
      setOptions(staticOptions);
    }
  }, [array, staticOptions, hasSearched]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setLoading(false);
    if (onOptionSelected) onOptionSelected(name, newValue);
   
  };

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };
  
  return (
    <Autocomplete
      labelId={labelId}
      id={id}
      label={label}
      name={name}
      className={className}
      style={{ margin: 0 }}
      open={open}
      disabled={disabled}
      noOptionsText={inputValue  ? t('autocomplete.noOptions') : t('autocomplete.typeToSearch')}
      loadingText={t('status.loading')}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
        setHasSearched(false);
        setOptions(staticOptions);
      }}
      isOptionEqualToValue={(option, value) => option.id === value?.id}
      getOptionLabel={(option) => {
        if (tipo === 'nombre') {
          return `${option.nombre} ${option.apellidos}`;
        } else if (tipo === 'razonSocial') {
          return `${option.razonSocial}`;
        } else {
          return '';
        }
      }}
      options={options}
      loading={loading}
      value={value}
      onChange={handleChange}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      renderOption={(props, option) => {
        const isStatic = staticOptions.some(s => s.id === option.id);
        const label = tipo === 'nombre'
          ? `${option.nombre} ${option.apellidos}`
          : tipo === 'razonSocial'
            ? option.razonSocial
            : '';
        return (
          <li {...props} key={option.id} style={isStatic ? { fontStyle: 'italic' } : {}}>
            {label}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          style={{ margin: 0, padding: 0 }}
          inputProps={{
            ...params.inputProps,
            style: { fontSize: '12px', margin: 0, padding: 0 }
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {<CircularProgress color="inherit" size={20} sx={{display:mostrarCargar}} /> }
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
